import routes from './routes.json';

export const SITE_URL = 'https://glauncher.kz';
export const SOCIAL_IMAGE = `${SITE_URL}/brand/social-card.png`;
export type PageMetadata = { title: string; description: string; path: string; indexable: boolean; image?: string; article?: boolean; schema?: object[] };

export function metadataForPath(path: string): PageMetadata {
  const route = routes.find((item) => item.path === path);
  if (route) return { ...route };
  const titles: Record<string, string> = {
    '/lots': 'Поиск лотов', '/suppliers': 'Поиск поставщиков', '/tracker': 'Отслеживание лотов',
    '/calculator': 'Финансовый анализ допуска', '/financial-planning': 'Финансовое планирование',
    '/experience': 'Расчёт опыта компании',
    '/profile': 'Личный кабинет', '/login': 'Вход', '/register': 'Регистрация',
    '/forgot-password': 'Восстановление пароля', '/verify-email': 'Подтверждение почты',
    '/payment/success': 'Результат оплаты', '/payment/failure': 'Результат оплаты',
  };
  const title = titles[path] || (path.startsWith('/admin') ? 'Управление сайтом' :
    path.startsWith('/lots/') ? 'Информация о лоте' : path.startsWith('/suppliers/') ? 'Информация о поставщике' :
    path.startsWith('/news/') ? 'Публикация' : 'Страница не найдена');
  return { path, title: `${title} — G-Launcher`, description: title, indexable: false };
}

function meta(attribute: 'name' | 'property', key: string, value: string) {
  let node = document.head.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
  if (!node) { node = document.createElement('meta'); node.setAttribute(attribute, key); document.head.appendChild(node); }
  node.content = value;
}

export function applyPageMetadata(page: PageMetadata) {
  document.title = page.title;
  meta('name', 'description', page.description);
  meta('name', 'robots', page.indexable ? 'index, follow, max-image-preview:large' : 'noindex, follow');
  meta('property', 'og:site_name', 'G-Launcher');
  meta('property', 'og:title', page.title);
  meta('property', 'og:description', page.description);
  meta('property', 'og:type', page.article ? 'article' : 'website');
  meta('property', 'og:url', `${SITE_URL}${page.path}`);
  meta('property', 'og:image', page.image || SOCIAL_IMAGE);
  meta('property', 'og:locale', document.documentElement.lang === 'kk' ? 'kk_KZ' : 'ru_KZ');
  meta('name', 'twitter:card', 'summary_large_image');
  meta('name', 'twitter:title', page.title);
  meta('name', 'twitter:description', page.description);
  meta('name', 'twitter:image', page.image || SOCIAL_IMAGE);
  let canonical = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!canonical) { canonical = document.createElement('link'); canonical.rel = 'canonical'; document.head.appendChild(canonical); }
  canonical.href = `${SITE_URL}${page.path}`;
  document.getElementById('glauncher-structured-data')?.remove();
  if (page.schema?.length) {
    const script = document.createElement('script'); script.type = 'application/ld+json'; script.id = 'glauncher-structured-data';
    script.textContent = JSON.stringify({ '@context': 'https://schema.org', '@graph': page.schema }).replace(/</g, '\\u003c');
    document.head.appendChild(script);
  }
  document.documentElement.dataset.seoPath = page.path;
}
